import { useLingui } from '@lingui/react/macro';

import { useUser } from '@/hooks/useUser';
import { trpc } from '@/services/trpc';

export function useModelCatalog() {
  const { currentOrganizationId } = useUser();
  const { i18n } = useLingui();
  const query = trpc.organizations.modelCatalog.useQuery(
    { organizationId: currentOrganizationId ?? '' },
    { enabled: !!currentOrganizationId, staleTime: 60_000 },
  );
  const data =
    query.data?.organizationId === currentOrganizationId
      ? query.data
      : undefined;
  const locale: 'cs' | 'en' = i18n.locale.startsWith('cs') ? 'cs' : 'en';
  const money = (amount: number) =>
    new Intl.NumberFormat(locale === 'cs' ? 'cs-CZ' : 'en-US', {
      style: 'currency',
      currency: data?.currency ?? 'CZK',
      minimumFractionDigits: 2,
      maximumFractionDigits: amount !== 0 && Math.abs(amount) < 0.1 ? 4 : 2,
    }).format(amount);

  return { ...query, data, locale: locale as 'cs' | 'en', money };
}

export type CatalogModel = NonNullable<
  ReturnType<typeof useModelCatalog>['data']
>['models'][number];
